import { render } from "./inside.vue?vue&type=template&id=5fb0a205"
import script from "./inside.vue?vue&type=script&lang=js"
export * from "./inside.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__